import React from 'react';
import { HomeScreen } from './screens/HomeScreen';
import { ShortcutScreen } from './screens/ShortcutScreen';
import { PrivacyScreen } from './screens/PrivacyScreen';
import * as firebase from 'firebase/app';
import {
  BrowserRouter as Router,
  Switch,
  Route,
} from 'react-router-dom'
import 'firebase/analytics'
import './App.css';
import './style/Dark.css';

const firebaseConfig = {
  apiKey: "AIzaSyBVkHEh3hRu8wsexV6ghLynjSVQJ-6eCXE",
  authDomain: "hatecoronavirus.firebaseapp.com",
  databaseURL: "https://hatecoronavirus.firebaseio.com",
  projectId: "hatecoronavirus",
  storageBucket: "hatecoronavirus.appspot.com",
  messagingSenderId: "275326823454",
  appId: "1:275326823454:web:5314d4676567c29966d20f",
  measurementId: "G-FCJ266GFZH"
};

firebase.initializeApp(firebaseConfig);
firebase.analytics();

class App extends React.Component {

  render() {
    return (
      <div className="App">
        <Router>
          <Switch>
            <Route path="/" exact component={HomeScreen}>
            </Route>
            <Route path="/shortcuts" exact component={ShortcutScreen}>
            </Route>
            <Route path="/privacy" exact component={PrivacyScreen}></Route>
          </Switch>
        </Router>
      </div>
    );
  }
}

export default App;
